<!-- filepath: /Volumes/Data Partition/veins-freela/VeinsEnergia-api/assets/ui/inputs/generic-text-input.vue -->
<template>
  <b-form-group :label="label" :label-for="inputId" :description="description">
    <b-form-input
      :id="inputId"
      v-model="internalValue"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :state="isValid"
      :aria-describedby="`${inputId}-feedback`"
      :maxlength="maxlength"
      @input="handleChange"
      @blur="handleBlur"
    />
    <b-form-invalid-feedback :id="`${inputId}-feedback`">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'GenericTextInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    validationFunc: {
      type: Function,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    label: {
      type: String,
      default: 'Texto',
    },
    inputId: {
      type: String,
      default: 'generic-text-input',
    },
    description: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    invalidFeedback: {
      type: String,
      default: 'Valor inválido. Verifique e tente novamente.',
    },
  },
  data() {
    return {
      internalValue: this.value ? String(this.value) : '',
      isValid: this.state,
    };
  },
  watch: {
    value(newVal) {
      this.internalValue =
        newVal !== null && newVal !== undefined ? String(newVal) : '';
      this.validate();
    },
    state(newVal) {
      this.isValid = newVal;
    },
  },
  mounted() {
    if (this.internalValue) {
      this.validate();
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.internalValue);
      this.validate();
    },
    handleBlur() {
      this.validate();
    },
    validate() {
      if (!this.validationFunc) {
        this.isValid = this.required ? !!this.internalValue : null;
      } else {
        this.isValid = this.validationFunc(this.internalValue);
        this.$emit('validation-updated', this.isValid);
      }
    },
  },
};
</script>
